var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, state, property, query } from "lit/decorators.js";
import { map } from "lit/directives/map.js";
import { LitElement } from "lit";
import { html } from "lit";
import kvViewComponentCss from "./kv-view.css.js";
import Prism from 'prismjs';
Prism.manual = true;
import 'prismjs/components/prism-json.js';
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import prismCss from "../../css/prism.css.js";
import sharedCss from "../../css/shared.css.js";
import syntaxCss from "../../css/syntax.css.js";
// @ts-ignore
document.removeEventListener('DOMContentLoaded', Prism.highlightAll);
let KVViewComponent = class KVViewComponent extends LitElement {
    constructor() {
        super();
        this._data = new Map();
        this.keyLabel = 'Key';
        this.valueLabel = 'Value';
        this.showHeader = true;
        this.tiny = false;
    }
    set data(value) {
        if (value && value.size > 0) {
            this._data = value;
        }
    }
    render() {
        let headerData = html ``;
        if (this._data) {
            headerData = html `
                ${map(this._data, (i) => {
                if (!i[1] || i[1] == '') {
                    return html ``;
                }
                if (typeof i[1] === 'object') {
                    return html `
                            <tr>
                                <td class="${this.tiny ? 'tiny' : null}"><code>${i[0]}</code></td>
                                <td class="${this.tiny ? 'tiny' : null}">
                                    <pre style=""><code class="no-box" style="white-space: pre-wrap;  word-wrap: break-word;">${unsafeHTML(Prism.highlight(JSON.stringify(i[1], null, 2), Prism.languages['json'], 'json'))}</pre></code>
                                </td>
                            </tr>`;
                }
                if (typeof i[1] === 'number') {
                    return html `
                            <tr>
                                <td class="${this.tiny ? 'tiny' : null}"><code>${i[0]}</code></td>
                                <td class="${this.tiny ? 'tiny' : null}">${i[1]}</td>
                            </tr>`;
                }
                return html `
                        <tr>
                            <td class="${this.tiny ? 'tiny' : null}"><code>${i[0]}</code></td>
                            <td class="${this.tiny ? 'tiny' : null}">${unsafeHTML(i[1].toString())}</td>
                        </tr>`;
            })}
            `;
        }
        const noData = html `
            <div class="empty-data">
                <sl-icon name="mic-mute" class="mute-icon"></sl-icon>
                <br/>
                No data extracted!
            </div>`;
        let header = html `
            <thead>
            <tr>
                <th>${this.keyLabel}</th>
                <th>${this.valueLabel}</th>
            </tr>
            </thead>`;
        if (this.keyLabel == '' && this.valueLabel == '') {
            header = html ``;
        }
        const table = html `

            <div class="kv-table ${this.tiny ? 'tiny' : null}">
                <table>
                    ${this.showHeader ? header : null}
                    <tbody>
                    ${headerData}
                    </tbody>
                </table>
            </div>
        `;
        const output = this._data?.size > 0 ? table : noData;
        return html `${output}`;
    }
};
KVViewComponent.styles = [sharedCss, syntaxCss, prismCss, kvViewComponentCss];
__decorate([
    property()
], KVViewComponent.prototype, "keyLabel", void 0);
__decorate([
    property()
], KVViewComponent.prototype, "valueLabel", void 0);
__decorate([
    property({ type: Boolean })
], KVViewComponent.prototype, "showHeader", void 0);
__decorate([
    property({ type: Boolean })
], KVViewComponent.prototype, "tiny", void 0);
__decorate([
    state()
], KVViewComponent.prototype, "_data", void 0);
__decorate([
    query('.render-stream')
], KVViewComponent.prototype, "renderStream", void 0);
KVViewComponent = __decorate([
    customElement('pb33f-kv-view')
], KVViewComponent);
export { KVViewComponent };
